import React, { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";

import Link from "next/link";

import useAuthSession from "../../../lib/auth/hooks/useAuthSession";
import Typography from "../../common/Typography/Typography";
import Icon from "../../common/Icon/Icon";

import styles from "./AccountDropdown.module.css";
import useSignOut from "../../../lib/auth/hooks/useSignout";

const AccountDropdown = () => {
    const signOut = useSignOut();
    const { session } = useAuthSession({ required: true });
    const user = session?.user;
    return (
        <Menu as="div" className="hidden min-[1130px]:block relative">
            {({ open }) => (
                <Fragment>
                    <Menu.Button className={`${styles.accountDropdownTrigger} ${open ? styles.accountDropdownTriggerActive : ""}`}>
                        <Icon icon="user" width={21} height={21} className="shrink-0" />
                        <span>{user?.firstname || "User name"}</span>
                        <Icon icon="chevron_down" />
                    </Menu.Button>
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items className={`${styles.accountDropdown} divide-y divide-pine-900`}>
                            <div className={styles.accountDropdownGroup}>
                                <Menu.Item>
                                    <Link href="/profile" className={styles.accountMenuItem}>
                                        <Icon icon="settings" width={17.5} />
                                        <Typography color="midnight" variant="meta">
                                            Profile Settings
                                        </Typography>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item>
                                    <Link href="/profile/security-settings" className={styles.accountMenuItem}>
                                        <Icon icon="key" width={17.5} />
                                        <Typography variant="meta" color="midnight">
                                            Security Settings
                                        </Typography>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item>
                                    <Link href="/profile/notification-settings" className={styles.accountMenuItem}>
                                        <Icon icon="bell" width={17.5} />
                                        <Typography variant="meta" color="midnight">
                                            Notification Settings
                                        </Typography>
                                    </Link>
                                </Menu.Item>
                            </div>
                            <div className={styles.accountDropdownGroup}>
                                <Menu.Item>
                                    <button
                                        type="button"
                                        onClick={signOut}
                                        className={`${styles.accountMenuItem} ${styles.accountSignOut}`}
                                    >
                                        <Typography variant="meta">Sign out</Typography>
                                        <Icon icon="log_out" width={17.5} />
                                    </button>
                                </Menu.Item>
                            </div>
                        </Menu.Items>
                    </Transition>
                </Fragment>
            )}
        </Menu>
    );
};

export default AccountDropdown;
